export default function(value) {
    if(value)
        return value.toLocaleDateString();
}